import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/BillOfLading/components/SectionChallenges/SectionChallenges.module.scss';

const cn = classNames.bind(styles);

const SectionAbout = (): ReactElement => {
  return (
    <section className={cn('challenges')}>
      <div className={cn('container')}>

        <div className={cn('challenges__heading-box')}>
          <h2 className={cn('challenges__heading')}>Challenges Faced by Freight Forwarders and NVOCC Managers</h2>
          <p className={cn('challenges__heading-description')}>
            Freight forwarders and NVOCC managers can face several challenges related to Bills of Lading during their
            day-to-day operations:
          </p>
        </div>

        <ul className={cn('challenges__benefits')}>
          <li className={cn('challenges__benefit')}>
            <p className={cn('challenges__benefit-paragraph')}>
              <strong>Complex Documentation Processes: </strong>
              Managing multiple types of BoLs and ensuring they are accurately completed can be time-consuming and
              prone to errors.
            </p>
          </li>
          <li className={cn('challenges__benefit')}>
            <p className={cn('challenges__benefit-paragraph')}>
              <strong>Tracking and Monitoring:</strong> Keeping track of BoLs and the shipments they
              represent can be difficult, especially when dealing with multiple carriers and destinations. Using
              tracking data can help freight forwarders and NVOCC managers monitor shipments and improve transparency.
            </p>
          </li>
          <li className={cn('challenges__benefit')}>
            <p className={cn('challenges__benefit-paragraph')}>
              <strong>Compliance and Legal Issues: </strong>
              Navigating the various legal requirements and ensuring compliance with international and national
              regulations requires expertise and attention to detail.
            </p>
          </li>
          <li className={cn('challenges__benefit')}>
            <p className={cn('challenges__benefit-paragraph')}>
              <strong>Time Consuming Administration:</strong> The paperwork and administrative tasks
              associated with BoLs can be overwhelming, leading to inefficiencies and increased operational costs.
            </p>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default SectionAbout;